import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Logo } from "../components/Logo";

export default function PrivacyPage() {
    useEffect(() => { document.title = "Privacy | SafetyDesk81"; }, []);

    return (
        <div className="min-h-screen bg-white">
            <header className="border-b border-navy-100 py-5 px-6"><Link to="/"><Logo size="md" /></Link></header>
            <main className="max-w-3xl mx-auto px-5 md:px-8 py-16 prose prose-navy">
                <h1 className="font-display font-extrabold text-navy-950 text-4xl md:text-5xl">Informativa Privacy</h1>
                <p className="mt-4 text-navy-500 text-sm">Ultimo aggiornamento: dicembre 2025</p>

                <section className="mt-10 space-y-6 text-navy-800 leading-relaxed">
                    <div>
                        <h2 className="font-display font-bold text-navy-950 text-2xl">Titolare del trattamento</h2>
                        <p>Il titolare del trattamento è <strong>Centro Sicurezza Consulenze</strong>. Per ogni comunicazione relativa alla privacy puoi scrivere a <a className="text-navy-950 underline" href="mailto:info@centrosicurezzaconsulenze.net">info@centrosicurezzaconsulenze.net</a>.</p>
                    </div>

                    <div>
                        <h2 className="font-display font-bold text-navy-950 text-2xl">Dati raccolti attraverso il modulo di iscrizione</h2>
                        <p>Nome, cognome, azienda, ruolo, email, telefono e, se forniti, numero indicativo di lavoratori, area di interesse, note libere.</p>
                    </div>

                    <div>
                        <h2 className="font-display font-bold text-navy-950 text-2xl">Finalità di gestione dell'iscrizione</h2>
                        <p>Base giuridica: consenso esplicito (Art. 6 GDPR). I dati sono utilizzati esclusivamente per gestire l'iscrizione all'evento di presentazione di SafetyDesk81 previsto per ottobre 2026, inviare la conferma di iscrizione, aggiornamenti sull'evento e comunicazioni operative correlate. I dati sono conservati per il tempo strettamente necessario alla gestione dell'evento e successivamente cancellati o anonimizzati.</p>
                    </div>

                    <div>
                        <h2 className="font-display font-bold text-navy-950 text-2xl">Finalità marketing (facoltativa e separata)</h2>
                        <p>Solo previo consenso esplicito e separato (checkbox non preselezionata), i dati possono essere utilizzati per l'invio di aggiornamenti e comunicazioni relative a SafetyDesk81 e ai servizi di Centro Sicurezza Consulenze. Puoi revocare il consenso in qualsiasi momento scrivendo a <a className="text-navy-950 underline" href="mailto:info@centrosicurezzaconsulenze.net">info@centrosicurezzaconsulenze.net</a>.</p>
                    </div>

                    <div>
                        <h2 className="font-display font-bold text-navy-950 text-2xl">Modalità del trattamento</h2>
                        <p>I dati vengono trattati con strumenti informatici. Il trasporto dei messaggi email è affidato a Brevo (Sendinblue), fornitore che agisce in qualità di responsabile del trattamento e opera in conformità al GDPR. Non vengono utilizzati dati per profilazione automatizzata.</p>
                    </div>

                    <div>
                        <h2 className="font-display font-bold text-navy-950 text-2xl">Diritti dell'interessato</h2>
                        <p>Hai diritto di accesso, rettifica, cancellazione, limitazione, opposizione e portabilità dei tuoi dati (Artt. 15-22 GDPR). Per esercitare i tuoi diritti scrivi a <a className="text-navy-950 underline" href="mailto:info@centrosicurezzaconsulenze.net">info@centrosicurezzaconsulenze.net</a>.</p>
                    </div>

                    <div>
                        <h2 className="font-display font-bold text-navy-950 text-2xl">Cookie e strumenti terzi</h2>
                        <p>La landing utilizza esclusivamente cookie tecnici necessari al funzionamento (sessione, sicurezza). Eventuali strumenti di analytics (Google Analytics 4) saranno attivati solo previo consenso e non sono attualmente in funzione.</p>
                    </div>

                    <div>
                        <h2 className="font-display font-bold text-navy-950 text-2xl">Data e ora dei consensi</h2>
                        <p>Ogni consenso raccolto è memorizzato con timestamp (data e ora), separatamente per la finalità di iscrizione e per la finalità marketing.</p>
                    </div>
                </section>

                <div className="mt-16"><Link to="/" className="text-navy-950 underline">← Torna alla landing</Link></div>
            </main>
        </div>
    );
}
